import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";

import tracv from "../../Assets/Projects/elephants.jpg";
import bpr from "../../Assets/Projects/bpr.JPG";
import gluco from "../../Assets/Projects/gluco.JPG";
import edifice from "../../Assets/Projects/edifice.png";
import yoyo from "../../Assets/Projects/yoyo.jpg";
import pos from "../../Assets/Projects/pos.jpg";
import drone from "../../Assets/Projects/drone.jpg";
import elocweb from "../../Assets/Projects/eloc-web.PNG";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
         <strong className="purple">Project Experience </strong>
        </h1>
     
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={drone}
              isBlog={false}
              title="Using Multispectral UAV Imagery for Marine Debris Detection in Sri Lanka | June 2023 - Present "
              description="A research project focused on the utilization of multispectral UAV imagery for continuous monitoring of floating and onshore marine debris in coastal areas of Sri Lanka. Tasked with developing and refining an automated detection method for identifying marine debris as well as an advanced material classification technique for the captured images. Research domains include Geographical Information Systems and Computer Vision. | Python, MicaSense Library, OpenCV"
              link=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={elocweb}
              isBlog={false}
              title="Decentralized Heterogeneous Edge AI for Efficient Elephant Tracking | June 2022 - May 2023 "
              description="The study focused on the energy-efficient operation of Eloc, a resource-constrained edge device used for elephant rumble detection in forested areas. It assessed energy consumption by contrasting on-device sound classification with sending only results to a base station via the network and transmitting the entire recorded data over the network for subsequent classification. Furthermore, the study introduced Eloc-Web, a visualization tool for mapping the estimated elephant locations based on acoustic localization, specifically accounting for the uncertainty associated with machine learning-based detection. Research domains include Geographical Information Systems, Embedded Systems, Machine Learning and Sensor Networks. | Python, C/C++, FLoRA, OMNeT++, React.js, Leaflet.js"
              link=""
            />
          </Col>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tracv}
              isBlog={false}
              title="ELOC Software | Oct 2021 - April 2022"
              description="A sound processing pipeline that would automatically detect elephant rumbles recorded by the ELOC node, which is a low-cost infrasonic detector designed to detect elephant rumbles. A novel digital signal processing approach known as Wavelet Transform is utilized for robust feature extraction and noise denoising of the elephant sounds. Domains of research focus include Digital Signal Processing, Machine Learning, Passive Acoustic Monitoring, and Embedded Systems. | Python, librosa, PyWavelets, scikit-learn, TensorFlow,
              Keras"
              link="https://github.com/vinuri-s/A-Robust-Feature-Extraction-Pipeline-for-Detecting-Elephant-Rumbles"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={edifice}
              isBlog={false}
              title="Edifice | May 2021 - Oct 2021"
              description="A Construction Project Management System that construction companies can use to manage all phases and aspects of a project, from start to completion, including project management, financial management, and resource management.  | React.js, Node.js, MySQL"
              link="https://github.com/vinuri-s/Edifice"
            />
          </Col>

 

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gluco}
              isBlog={false}
              title="GLUCO | Feb 2020 – Feb 2021"
              description="The project consists of a Web and Mobile Application for diabetes self-management, which is helpful for diabetic patients, as well as a separate web platform for diabetes data analysis for the benefit of health researchers. | PHP, HTML, CSS, JavaScript, Java, SQLite, 3-Tier Architecture"
              link="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pos}
              isBlog={false}
              title="Grand Stores | May 2021"
              description="A complete wholesale management system with features for managing items, customers, and orders. | Java, JavaFX/Swing, SQL, Layered Architecture, Singleton Pattern, Factory Design Pattern"
              link="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={yoyo}
              isBlog={false}
              title="YoYo | Sep 2019 - Dec 2019 "
              description="Online Sales & Marketing Web Application | PHP, HTML, CSS, JavaScript, MySQL"
              link="#"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bpr}
              isBlog={false}
              title="BPR Group Project | Sep 2020 -Feb 2021"
              description=""
              link="https://sites.google.com/view/bpr-group-project/home"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
